export const CardTeamSelect = {
  name: "card-team-select",
  component: "MainPanel",
  layout: "main-panel padded align-center",
  mode: "visible",
  text: "card.select-team",
  showOn: [{ state: "primary", value: "card-team-select", operator: "is" }],
  allowCancel: true,
  children: [
    {
      name: "team-0",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: { team: "name" },
      showOn: [true],
      options: { team: 0 },
      startPlay: false,
      startEvent: false,
      actionGroups: [
        {
          actions: [
            {
              action: "nextState",
              value: "card-type",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "team-1",
      component: "TypeButton",
      layout: "match-button",
      mode: "enable",
      text: { team: "name" },
      showOn: [true],
      options: { team: 1 },
      startPlay: false,
      startEvent: false,
      actionGroups: [
        {
          actions: [
            {
              action: "nextState",
              value: "card-type",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
